import React, { useEffect, useState, useCallback } from "react";
import TableHeader from "../../TableHeader";
import TableBody from "../../TableBody";
import { SemanticTable } from "./styles";

const Table = (props) => {
  const [header, setHeader] = useState([
    "CURSO ID",
    "NOME CURSO",
    "ID PESSOA",
    "NOME",
    "CPF",
    "E-MAIL",
    "CELULAR",
    "CIDADE",
    "ESTADO",
    "ID INSCRICAO",
    "ID PEDIDO",
    "DATA INSCRICAO",
    "DESCONTO",
    "VOUCHER",
    "BANDEIRA",
    "Nº PARCELAS",
    "VALOR PARCELA",
    "TAXAS CARTAO",
    "VALOR PGTO 01",
    "FORMA PGTO 01",
    "DATA PGTO 01",
    "VALOR PGTO 02",
    "FORMA PGTO 02",
    "DATA PGTO 02",
    "VALOR PGTO 03",
    "FORMA PGTO 03",
    "DATA PGTO 03",
    "VALOR PGTO 04",
    "FORMA PGTO 04",
    "DATA PGTO 04",
    "VALOR DESCONTADO AS TAXAS",
    "VALOR FINAL",
    "STATUS",
    "MATERIAL IMPRESSO",
    "CERTIFICADO IMPRESSO",
    "OPERADOR PAGAMENTO",
    "DIGITAL OU TREINAMENTO",
    "DATA PAGAMENTO",
  ]);
  const [body, setBody] = useState([[]]);

  const getLineCells = useCallback(() => {}, [props]);

  const status = [
    "Em aberto",
    "Em aberto",
    "Pendente",
    "Concluído",
    "Entrada",
    "Desistiu",
    "Estorno",
    "Crédito",
  ];

  useEffect(() => {
    console.log("PROPS INSCRICOES", props.inscricoes);

    const newBody = props.inscricoes.map(
      (inscricao) =>
        Object.keys(inscricao).map((key) => (
          <div>
            {key !== "status" ? inscricao[key] : status[inscricao[key]]}
          </div>
        ))
      // (inscricao) => Object.values(inscricao).map((value) => <div>{value}</div>)
    );

    setBody(newBody);
  }, [props]);

  return (
    <SemanticTable>
      <TableHeader header={header} />
      <TableBody body={body} />
    </SemanticTable>
  );
};

export default Table;
